module.exports = __webpack_public_path__ + "img/everTrust-logo.69b390d2.png";